/**
 * @name 渲染表单组件
 */
import base from '../../base';
import FormBuild from './form-build';

FormBuild.install = function(Vue) {
  Vue.use(base);
  Vue.component(FormBuild.name, FormBuild);
};

export default FormBuild;
